/* This is generated code, don't alter */
var shading_surface_method;
(function (shading_surface_method) {
    shading_surface_method[shading_surface_method["CONSTANT_SHADING"] = 0] = "CONSTANT_SHADING";
    shading_surface_method[shading_surface_method["COLOUR_SHADING"] = 1] = "COLOUR_SHADING";
    shading_surface_method[shading_surface_method["DOT_SHADING"] = 2] = "DOT_SHADING";
    shading_surface_method[shading_surface_method["NORMAL_SHADING"] = 3] = "NORMAL_SHADING";
})(shading_surface_method || (shading_surface_method = {}));
const shading_surface_methodCount = 4;
export { shading_surface_method, shading_surface_methodCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapshading_surface_method = new Int32Array([1]);
let prefixSumAddressshading_surface_method = new Uint32Array([0, 16, 34, 47, 63]);
let slotMapshading_surface_method = new Int32Array([1, 0, 2, 3]);
let encodedDatashading_surface_method = (new TextEncoder()).encode(".COLOUR_SHADING..CONSTANT_SHADING..DOT_SHADING..NORMAL_SHADING.");
let shading_surface_methodSearch = new MinimalPerfectHash(gMapshading_surface_method, prefixSumAddressshading_surface_method, slotMapshading_surface_method, encodedDatashading_surface_method);
export { shading_surface_methodSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function shading_surface_methodDeserializeStep(input, cursor, endCursor) {
    return parser.extract(shading_surface_methodSearch, input, cursor, endCursor);
}
